// Configuration file for Universal Pays landing page

declare global {
  interface ImportMetaEnv {
    readonly VITE_NEXT_PUBLIC_LOGIN_URL: string
    readonly VITE_NEXT_PUBLIC_SIGNUP_URL: string
    readonly VITE_NEXT_PUBLIC_DASHBOARD_URL: string
  }
  interface ImportMeta {
    readonly env: ImportMetaEnv
  }
}

export const config = {
  // External links
  links: {
    getStarted: import.meta.env.VITE_NEXT_PUBLIC_DASHBOARD_URL || "#",
    documentation: "#", // Replace with documentation URL
    login: import.meta.env.VITE_NEXT_PUBLIC_LOGIN_URL || "#",
    signup: import.meta.env.VITE_NEXT_PUBLIC_SIGNUP_URL || "#",
    dashboard: import.meta.env.VITE_NEXT_PUBLIC_DASHBOARD_URL || "#",
    support: "#", // Replace with support URL
  },
  
  // Contact information
  contact: {
    email: "support@universalpays.com",
    phone: "+13658290725",
    address: "123 Payment Street, Fintech City, FC 12345",
  },
  
  // Social media links
  social: {
    twitter: "#",
    linkedin: "#",
    facebook: "#",
    telegram: "#",
  },
  
  // Company information
  company: {
    name: "Universal Pays",
    tagline: "Global Payment Solutions",
    description: "Easily integrate wire transfers, cryptocurrency, card payments, and eVoucher solutions into your system for a seamless transaction experience.",
  },
  
  // Feature flags
  features: {
    testimonialToaster: true,
    floatingContactButton: true,
    darkMode: true,
  }
}

export default config
